import React, { useState } from "react"
import {
  Row,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Col,
  ModalBody,
  Modal,
  ModalHeader,
  ModalFooter,
  Button,
} from "reactstrap"
import LazyHero from "react-lazy-hero"
import DataImgSrc from "./imgs/data.jpg"
import QRCode from "qrcode.react"
import htmlToImage from "html-to-image"
import download from "downloadjs"
import axios from "axios"
import RequestID from "./utils/ResID"
import Spinner from "./Spinner"
import { Link } from "react-router-dom"

// Generate random response ID
const responseID = RequestID(new Date())

// Getting the Facility ID
const x = window.location.href
var windowID = x.split("/")
var FID = windowID[4]

const PROD_ENV = `https://hdform.herokuapp.com/api/facility/respond/${FID}`

const DataImage = () => {
  return (
    <div className="hero-img-padding-top">
      <LazyHero
        color={"white"}
        opacity={0.1}
        imageSrc={DataImgSrc}
        minHeight={"20vh"}
      />
    </div>
  )
}

function HDForm() {
  const [name, setName] = useState("")
  const [mobile, setMobile] = useState("")
  const [address, setAddress] = useState("")
  const [email, setEmail] = useState("")
  const [age, setAge] = useState("")
  const [sex, setSex] = useState("")
  const [travel, setTravel] = useState("")
  const [symptoms, setSymptoms] = useState("")
  const [suspect, setSuspect] = useState("")
  const [temp, setTemp] = useState("")

  // Modal handlers
  const [open, setOpen] = useState(false)
  const [focusAfterClose, setFocusAfterClose] = useState(true)
  const showSuccessModal = () => setOpen(!open)
  const handleSelectChange = ({ target: { value } }) => {
    setFocusAfterClose(JSON.parse(value))
  }

  // Loading handler
  const [loading, setLoading] = useState(false)

  function SuccessConfirmation() {
    // QR code to display response confirmation
    // Saving QR code to device
    const saveQR = () => {
      const canvas = document.getElementById(responseID)
      htmlToImage.toPng(canvas).then(function (dataUrl) {
        download(dataUrl, `${responseID}.png`)
      })
    }

    // Redirect page on-close to other link
    const closeApp = () => {
      window.location.replace("/")
    }

    const ConfirmationQR = () => {
      return (
        <Container className="qr-top-padding">
          <QRCode
            bgColor="#ffffff"
            fgColor="#341f97"
            size={200}
            value={`Response ID: ${responseID}`}
            renderAs="canvas"
            level="L"
            className="img-responsive container-fluid"
            includeMargin={true}
          />
        </Container>
      )
    }
    return (
      <Container>
        <Modal returnFocusAfterClose={focusAfterClose} isOpen={open}>
          <ModalBody id={responseID} className="qr-confirmation">
            <ModalHeader className="success-modal-header text-center">
              Your response has been successfully submitted!
            </ModalHeader>
            <ConfirmationQR />
            <p className="resID-code">Response ID: {responseID}</p>
            <p className="resID-date">Date: {new Date().toLocaleString()}</p>
            <Container className="qr-text text-center">
              <a href="https://hdform.now.sh" className="text-center qr-text">
                https://hdform.now.sh
              </a>
              <p className="qr-info">
                You may present this completion code to our security officer as
                proof of completion. You may now close this window.
              </p>
            </Container>
          </ModalBody>
          <ModalFooter>
            <Row>
              <Button onClick={saveQR}>Save QR</Button>
              <Button onClick={closeApp}>Close</Button>
            </Row>
          </ModalFooter>
        </Modal>
      </Container>
    )
  }

  const submitResponse = (e) => {
    e.preventDefault()
    setLoading(true)
    const userResponse = {
      active: true,
      date: new Date().toLocaleString(),
      responseID: responseID,
      name: name,
      mobile: mobile,
      email: email,
      address: address,
      temp: temp,
      age: age,
      sex: sex,
      has_travelled: travel,
      has_symptoms: symptoms,
      is_suspect: suspect,
    }

    axios
      .post(PROD_ENV, userResponse)
      .then((res) => showSuccessModal())
      .catch((err) => alert(`Error: ${err}. Please try again`))
      .finally(() => setLoading(false))
  }

  return (
    <div>
      <DataImage />
      {loading === true ? (
        <Spinner />
      ) : (
        <Container className="hdf-top-padding">
          <h1 className="text-center">Health Declaration Form</h1>
          <Form className="form-top-padding" onSubmit={submitResponse}>
            <Container fluid>
              <Row>
                <Label>Name</Label>
                <Input
                  type="text"
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Your name"
                  required
                />
              </Row>
              <Row>
                <Label>Mobile No.</Label>
                <Input
                  type="tel"
                  placeholder="Ex 09171234567"
                  required
                  onChange={(e) => setMobile(e.target.value)}
                  minLength="11"
                  maxLength="11"
                />
              </Row>
              <Row>
                <Label for="exampleState">Email Address</Label>
                <Input
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  placeholder="youremail@yourdomain.com"
                />
              </Row>
              <Row>
                <Label>Address</Label>
                <Input
                  type="text"
                  name="address"
                  onChange={(e) => setAddress(e.target.value)}
                  placeholder="House or Building No / Street / Barangay"
                  required
                />
              </Row>
              <Row>
                <FormGroup>
                  <Label for="sex">Sex</Label>
                  <select
                    className="form-control"
                    required
                    name="sex"
                    onChange={(e) => setSex(e.target.value)}
                  >
                    <option value="" disabled>
                      Choose Gender
                    </option>
                    <option value="Female">Female</option>
                    <option value="Male">Male</option>
                  </select>
                </FormGroup>
              </Row>
              <Row>
                <Label>Age</Label>
                <Input
                  type="number"
                  onChange={(e) => setAge(e.target.value)}
                  required
                  placeholder="Ex: 27"
                  max="99"
                  min="18"
                />
              </Row>
              <Row>
                <FormGroup className="q-padding">
                  <Label className="questions-font">Temperature</Label>
                  <Input
                    type="number"
                    onChange={(e) => setTemp(e.target.value)}
                    placeholder="Ex: 36.5"
                  />
                </FormGroup>
              </Row>
              <Row>
                <FormGroup className="q-padding">
                  <Label className="questions-font" for="travel">
                    Have you travelled outside the country for the last 14 days?
                  </Label>
                  <select
                    className="form-control"
                    required
                    name="travel"
                    onChange={(e) => setTravel(e.target.value)}
                  >
                    <option value="">Choose YES or NO</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </FormGroup>
              </Row>
              <Row>
                <FormGroup className="q-padding">
                  <Label className="questions-font" for="symptoms">
                    In the last 14 days, did you have any of the following:
                    fever, colds, cough, sore throat, loss of smell and taste,
                    muscle pain, headache or difficulty in breathing?
                  </Label>
                  <div>
                    <select
                      className="form-control"
                      required
                      name="symptoms"
                      onChange={(e) => setSymptoms(e.target.value)}
                    >
                      <option value="" disabled>
                        Choose YES or NO
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </FormGroup>
              </Row>
              <Row>
                <FormGroup className="q-padding">
                  <Label className="questions-font" for="contact">
                    In the last 14 days, have you been in close contact or
                    exposed to any person suspected of or confirmed with
                    COVID-19?
                  </Label>
                  <select
                    className="form-control"
                    name="contact"
                    required
                    onChange={(e) => setSuspect(e.target.value)}
                  >
                    <option value="" disabled>
                      Choose YES or NO
                    </option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </FormGroup>
              </Row>
              <Container>
                <Row className="form-submit">
                  <p className="terms">
                    By submitting this form, you confirm that the above
                    information is correct, you understand that falsification of
                    information may incriminate you and you agree to our{" "}
                    <Link to="/terms-of-use#terms">Terms of Use</Link>
                  </p>
                </Row>
              </Container>
              <Row className="text-center">
                <div className="form-submit-bottom-padding text-center">
                  <Button color="primary">Submit Response</Button>
                  <Link to="/">
                    <Button className="btn btn-secondary">Back</Button>
                  </Link>
                </div>
              </Row>
            </Container>
          </Form>
          <SuccessConfirmation />
        </Container>
      )}
    </div>
  )
}

export default HDForm
